function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

function reportInputValidity(input, errorBlock) {
  if (!input || !errorBlock) return false;

  const type = input.type;
  const value = input.value.trim();
  let isValid = true;
  let errorType = "empty";

  isValid = value === "" ? false : true;

  switch (type) {
    case "email":
      if (value !== "" && !input.checkValidity()) {        
        isValid = false;
        errorType = "email"
      }
      break;
  }

  if (isValid) {
    input.removeAttribute("aria-invalid");
    errorBlock.innerText = "";
  } else {
    input.setAttribute("aria-invalid", true);
    errorBlock.innerText = window.errorStrings[errorType];
  }

  return isValid;
}

class Header {
  constructor(root) {
    this.root = root;
    this.mobileMenu = this.root.querySelector("#MobileMenu");

    this.headerSearch = this.root.querySelector('#HeaderSearchDrawer');
    this.headerSearchInput = this.root.querySelector('#HeaderSearchInput');
    this.headerPredictiveResults = this.root.querySelector("#HeaderPredictiveResults");

    this.headerContact = this.root.querySelector('#HeaderContactPopup');

    this.allAnnouncementsHeight = 0;
    this.isLoading = false;

    this.root.addEventListener('click', this.onClick.bind(this));
    
    this.calcHeader();
    window.addEventListener('scroll', () => {
      this.root.classList.toggle('sticky', window.scrollY >= this.allAnnouncementsHeight);
    });

    if (this.headerSearchInput) {
      this.headerSearchInput.addEventListener('input', debounce((e) => {
        this.onPredictiveChange(e.target.value);
      }, 500).bind(this));

      this.headerSearchInput.closest("form").addEventListener('submit', (e) => {
        e.preventDefault();
      });
    }
  }

  onPredictiveChange(query) {
    if (this.isLoading) return;

    if (query === "") {
      this.headerPredictiveResults.innerHTML = "";
      return;
    }

    this.isLoading = !this.isLoading;

    const searchUrl = `/search/suggest?q=${encodeURIComponent(query.trim())}&resources[type]=product&section_id=predictive-results`;

    fetch(searchUrl)
    .then(response => {
      if (!response.ok) {
        this.headerPredictiveResults.innerHTML = "";
        return;
      }

      return response.text();
    })
    .then(response => {
      const responseMarkup = new DOMParser().parseFromString(response, 'text/html');
      this.headerPredictiveResults.innerHTML = responseMarkup.querySelector("#shopify-section-predictive-results").innerHTML;
    })
    .catch(error => console.error(error))
    .finally(() => this.isLoading = !this.isLoading)
  }
  
  calcHeader() {
		const headerObserver = new ResizeObserver(() => {
			this.headerHeight = this.root.getBoundingClientRect().height;
			document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);

      const announcements = document.querySelectorAll(".announcement");
      this.allAnnouncementsHeight = Math.max(Array.from(announcements).reduce((sum, el) => {
        return sum + el.offsetHeight;
      }, 0), 1);
      
      this.root.classList.toggle('sticky', window.scrollY >= this.allAnnouncementsHeight);
		});

		headerObserver.observe(this.root);
	}

  onClick(event) {
    if (event.target.hasAttribute("data-action")) {
      switch (event.target.dataset.action) {
        case "search-close":
          this.headerSearch.classList.remove("open");
          document.documentElement.style.overflow = null;
          break;
        case "search-open":
          this.headerSearch.classList.add("open");
          document.documentElement.style.overflow = "hidden";
          break;
        case "search-submit":
          this.onPredictiveChange(this.headerSearchInput.value);
          break;
        case "toggle-submenu":
          const submenu = event.target.nextElementSibling;
            
          event.target.classList.toggle("active");
          submenu.style.maxHeight = event.target.classList.contains("active") ? submenu.scrollHeight + "px" : null;
          break;
        case "drawer-open":
          this.mobileMenu.classList.add("open");
          document.documentElement.style.overflow = "hidden";
          break;
        case "drawer-close":
          this.mobileMenu.classList.remove("open");
          document.documentElement.style.overflow = null;
          break;
        case "contact-open":
          this.headerContact.classList.add("open");
          document.documentElement.style.overflow = "hidden";
          break;
        case "contact-close":
          this.headerContact.classList.remove("open");
          document.documentElement.style.overflow = null;
          break;
      }
    }
  }
}

if (document.querySelector("header")) {
  new Header(document.querySelector("header"))
}

class SliderComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.currentSlide = 1;
    this.allowEvents = this.getAttribute("data-allow-events") === "true";
    this.hideControls = this.getAttribute("data-hide-controls") !== "false"
    this.skipMaxLength = this.getAttribute("data-single-slide") === "true";

    this.slider = this.querySelector('[id^="Slider-"]');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    this.scrollbar = this.querySelector("[slider-scrollbar]");
    this.scrollbarThumb = this.querySelector("[slider-scrollbar] span");

    this.pagination = this.querySelector('[slider-pagination]');

    this.counter = this.querySelector('[slider-counter]');

    if (!this.slider) return;

    this.update();
    window.addEventListener('resize', this.update.bind(this));
    this.slider.addEventListener('scroll', this.update.bind(this));

    if (this.prevButton && this.nextButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    if (this.pagination) {
      this.pagination.addEventListener("click", this.onDotClick.bind(this))
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    if (event.currentTarget.name === 'previous' && this.currentSlide > 1) {
      this.currentSlide -= 1;
    } else if (event.currentTarget.name === 'next' && this.currentSlide < this.maxLength) {
      this.currentSlide += 1;
    }
    this.scrollToSlide(this.currentSlide);
  }

  onDotClick(event) {
    event.preventDefault();
    if (!event.target.hasAttribute("data-slide")) return;

    const slideIndex = parseInt(event.target.dataset.slide);
    this.scrollToSlide(slideIndex);
  }

  scrollToSlide(index) {
    this.slider.scrollTo({
      left: this.querySelector(`[id^="Slide-"]:nth-child(${index})`).offsetLeft,
      behavior: 'smooth'
    });
  }

  update() {
    const items = this.querySelectorAll('[id^="Slide-"]');
    const scrollLeft = this.slider.scrollLeft;
    const scrollWidth = this.slider.scrollWidth;
    const clientWidth = this.slider.clientWidth;
    const blockWidth = items[0]?.offsetWidth ?? 0;
    const gap = window.innerWidth < 750 ? 12 : 16;
    const hasScroll = this.slider.scrollWidth > clientWidth;
      
    this.maxLength = items.length - (Math.floor(clientWidth / blockWidth) - 1);
    this.currentSlide = Math.round(scrollLeft / (blockWidth + gap)) + 1;

    if (this.skipMaxLength) {
      this.maxLength = items.length;
    }

    items.forEach((item, index) => item.classList.toggle("active", index + 1 == this.currentSlide));
    
    if (this.prevButton && this.nextButton) {
      this.prevButton.toggleAttribute("disabled", this.currentSlide == 1);
      this.nextButton.toggleAttribute("disabled", this.currentSlide == this.maxLength);
  
      if (this.hideControls) {
        this.prevButton.classList.toggle("hidden", !hasScroll);
        this.nextButton.classList.toggle("hidden", !hasScroll);
      }
    }

    if (this.scrollbarThumb) {      
      const thumbWidth = (clientWidth / scrollWidth) * 100;
      const thumbPosition = (scrollLeft / (scrollWidth - clientWidth)) * 100;

      this.scrollbarThumb.style.left = `${thumbPosition}%`;
      this.scrollbarThumb.style.width = `${thumbWidth}%`;
      this.scrollbarThumb.style.transform = `translateX(-${thumbPosition}%)`;
      this.scrollbar.classList.toggle("hidden", !hasScroll);
    }

    if (this.pagination) {
      this.updatePagination();
    }


    if (this.counter) {
      this.counter.innerHTML = `${this.currentSlide} / ${items.length}`;
    }  
  
    if (this.allowEvents) {
      this.dispatchEvent(
        new CustomEvent("slider-updated", {
          detail: {
            currentSlide: this.currentSlide
          },
          bubbles: true,
        })
      );
    }
  }

  updatePagination() {
    const slides = this.querySelectorAll('[id^="Slide-"]');

    if (!this.slider || slides.length === 0 || !this.pagination) return;

    const containerWidth = this.slider.clientWidth;
    const slideWidth = slides[0].offsetWidth;

    const slidesPerPage = Math.floor(containerWidth / slideWidth);
    const totalPages = slides.length - (slidesPerPage - 1);

    this.pagination.innerHTML = '';
    this.pagination.classList.toggle("hidden", totalPages === 1);

    for (let i = 1; i <= totalPages; i++) {
      const dot = document.createElement('span');
      dot.setAttribute("data-slide", i);
      if (i === this.currentSlide) dot.classList.add("active");
      this.pagination.appendChild(dot);
    }
  }
}

customElements.define("slider-component", SliderComponent);

class ProductCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.cart = document.querySelector("cart-drawer");
    this.isLoading = false;

    this.querySelector('.product-card__form')?.addEventListener("submit", this.onFormSubmit.bind(this));
  }

  onFormSubmit(event = false) {
    if (event) event.preventDefault();

    if (this.isLoading) return;

    const sections = [];
    if (this.cart) sections.push("cart-drawer");

    const cartData = {
      items: [
        {
          id: parseInt(this.querySelector("[name='id']").value),
          quantity: parseInt(this.querySelector("[name='quantity']").value)
        }
      ],
      sections: sections,
      sections_url: window.location.pathname
    };

    this.addToCart(cartData);
  }

  addToCart(data) {
    if (!data) return;

    this.toggleLoading();

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then(response => {
      if (!response.items) {
        const error = new Error(response.description);
        throw error;
      } else {
        this.toggleLoading();
        
        if (this.cart) {
          this.cart.renderContent(response.sections);
          this.cart.open();
        }
      }
    })
    .catch(error => this.showError(error))
    .finally(() => this.toggleLoading(true));
  }

  showError(error) {
    console.error(error);

    if (!this.querySelector("[product-notification]")) return;

    const messageBlock = this.querySelector("[product-notification]");

    messageBlock.innerText = error.message;
    setTimeout(() => {messageBlock.innerText = ''}, 5000);
    messageBlock.scrollIntoView({behavior: "smooth",block:"center"});
  }

  toggleLoading(turnOff = false) {
    this.isLoading = !this.isLoading;
    if (turnOff) this.isLoading = false;
    this.classList.toggle("loading", this.isLoading);
  }
}

customElements.define("product-card", ProductCard);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.cart = document.querySelector("cart-drawer");
    this.isLoading = false;

    this.querySelector('.upsell-card__form')?.addEventListener("submit", this.onFormSubmit.bind(this));
  }

  onFormSubmit(event = false) {
    if (event) event.preventDefault();

    if (this.isLoading) return;

    const sections = [];
    if (this.cart) sections.push("cart-drawer");

    const cartData = {
      items: [
        {
          id: parseInt(this.querySelector("[name='id']").value),
          quantity: parseInt(this.querySelector("[name='quantity']").value)
        }
      ],
      sections: sections,
      sections_url: window.location.pathname
    };

    this.addToCart(cartData);
  }

  addToCart(data) {
    if (!data) return;

    this.toggleLoading();

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then(response => {
      if (!response.items) {
        const error = new Error(response.description);
        throw error;
      } else {
        this.toggleLoading();
        
        if (this.cart) {
          this.cart.renderContent(response.sections);
          this.cart.open();
        }
      }
    })
    .catch(error => this.showError(error))
    .finally(() => this.toggleLoading(true));
  }

  showError(error) {
    console.error(error);

    if (!this.querySelector("[product-notification]")) return;

    const messageBlock = this.querySelector("[product-notification]");

    messageBlock.innerText = error.message;
    setTimeout(() => {messageBlock.innerText = ''}, 5000);
    messageBlock.scrollIntoView({behavior: "smooth",block:"center"});
  }

  toggleLoading(turnOff = false) {
    this.isLoading = !this.isLoading;
    if (turnOff) this.isLoading = false;
    this.classList.toggle("loading", this.isLoading);
  }
}

customElements.define("upsell-card", UpsellCard);

class MainCollection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.isLoading = false;
    this.currentPage = 1;
    this.sideWrapper = this.querySelector(".main-collection__side");
    this.filtersWrapper = this.querySelector('[id^="CollectionFilters-"]');
    this.productsGrid = this.querySelector('[id^="CollectionGrid-"]');
    
    this.initClickEvent();
  }

  filtersUpdate(exclusion = false, urlToRemove = false) {
    this.toggleLoading();
    this.currentPage = 1;

    let newProductUrl = urlToRemove;

    if (!newProductUrl) {
      const searchParams = new URLSearchParams();
      searchParams.append("sort_by", this.querySelector('[name="sort_by"]').value);
      
      if (this.filtersWrapper && exclusion !== "*") {
        this.filtersWrapper.querySelectorAll("input:checked").forEach(input => {
          if (exclusion !== input.name) {
            searchParams.append(input.name, input.value);
          }
        })

        this.filtersWrapper.querySelectorAll("price-range [data-fields] input").forEach(input => {
          const inputValue = parseInt(input.value);
          const inputMin = parseInt(input.min);
          const inputMax = parseInt(input.max);
          
          if (input.name === "filter.v.price.gte" && inputValue > inputMin) {
            searchParams.append(input.name, input.value);
          } else if (input.name === "filter.v.price.lte" && inputValue < inputMax) {
            searchParams.append(input.name, input.value);
          }
        })
      }
      
      newProductUrl = window.location.pathname + `?${searchParams.toString()}`;
    }
    
    window.history.replaceState({}, '', newProductUrl);

    fetch(newProductUrl)
    .then(res => res.text())
    .then(body => {
      const html = new DOMParser().parseFromString(body, "text/html");
      const section = html.querySelector(`[data-section="${this.dataset.section}"]`);
      const selectors = [
        '[data-bottom]',
        '[id^="CollectionGrid-"]'
      ];

      this.querySelectorAll("[data-index]").forEach(tab => {
        const currentTabLabel = tab.querySelector("[data-label]");
        const currentTabValues = tab.querySelector("[data-values]");
        const newTab = section.querySelector(`[data-index="${tab.dataset.index}"]`);        

        currentTabLabel.innerHTML = newTab.querySelector("[data-label]").innerHTML;
        currentTabValues.innerHTML = newTab.querySelector("[data-values]").innerHTML;

        if (currentTabLabel.classList.contains("open")) {
          currentTabValues.style.maxHeight = currentTabValues.scrollHeight + "px";
        }
      })

      selectors.forEach(selector => {
        if (this.querySelector(selector) && section.querySelector(selector)) {
          this.querySelectorAll(selector).forEach((selectorElement, i) => {
            selectorElement.innerHTML = section.querySelectorAll(selector)[i].innerHTML;
          })
        }
      })
    })
    .catch(error => console.error(error))
    .finally(() => this.toggleLoading())
  }

  initClickEvent() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-action")) {
        switch (e.target.dataset.action) {
          case "filter-toggle-option":
            e.target.classList.toggle("active");
            e.target.nextElementSibling.style.maxHeight = e.target.classList.contains("active") ? e.target.nextElementSibling.scrollHeight + "px" : null;
            break;
          case "filter-reset":
            if (!this.isLoading) this.filtersUpdate("*");
            break;
          case "filter-submit":
            if (!this.isLoading) {
              this.filtersUpdate();
              this.sideWrapper.classList.remove("open");
            }
            break;
          case "filter-open":
            this.sideWrapper.classList.add("open");
            break;
          case "filter-close":
            this.sideWrapper.classList.remove("open");
            break;
          case "load-more":
            this.loadMoreProducts();
            break;
          }
      }
    })
  }

  loadMoreProducts() {
    this.toggleLoading();
    this.currentPage++;

    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("page", this.currentPage);

    fetch(window.location.pathname + `?${searchParams.toString()}`)
    .then(res => res.text())
    .then(body => {
      const html = new DOMParser().parseFromString(body, "text/html");
      const section = html.querySelector(`[data-section="${this.dataset.section}"]`);

      const currentGrid = this.querySelector('[id^="CollectionGrid-"]');
      const newPageGrid = section.querySelector('[id^="CollectionGrid-"]');
      const newGridItems = newPageGrid.querySelectorAll("& > li");

      newGridItems.forEach(newGridItem => {
        currentGrid.append(newGridItem)
      })

      if (this.querySelector('[data-bottom]') && section.querySelector('[data-bottom]')) {
        this.querySelectorAll('[data-bottom]').forEach((selectorElement, i) => {
          selectorElement.innerHTML = section.querySelectorAll('[data-bottom]')[i].innerHTML;
        })
      }
    })
    .catch(error => console.error(error))
    .finally(() => this.toggleLoading())
  }

  toggleLoading() {
    this.isLoading = !this.isLoading;
    this.classList.toggle("loading", this.isLoading);
  }
}

if (document.querySelector("main-collection")) {
  customElements.define("main-collection", MainCollection);
}

class MainBlog extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.isLoading = false;
    this.currentPage = 1;
    
    this.initClickEvent();
  }

  initClickEvent() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-action")) {
        switch (e.target.dataset.action) {
          case "load-more":
            this.loadMoreProducts();
            break;
          }
      }
    })
  }

  loadMoreProducts() {
    this.toggleLoading();
    this.currentPage++;

    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("page", this.currentPage);

    fetch(window.location.pathname + `?${searchParams.toString()}`)
    .then(res => res.text())
    .then(body => {
      const html = new DOMParser().parseFromString(body, "text/html");
      const section = html.querySelector(`[data-section="${this.dataset.section}"]`);

      const currentGrid = this.querySelector('[id^="BlogGrid-"]');
      const newPageGrid = section.querySelector('[id^="BlogGrid-"]');
      const newGridItems = newPageGrid.querySelectorAll("& > li");

      newGridItems.forEach(newGridItem => {
        currentGrid.append(newGridItem)
      })

      if (this.querySelector('[data-bottom]') && section.querySelector('[data-bottom]')) {
        this.querySelectorAll('[data-bottom]').forEach((selectorElement, i) => {
          selectorElement.innerHTML = section.querySelectorAll('[data-bottom]')[i].innerHTML;
        })
      }
    })
    .catch(error => console.error(error))
    .finally(() => this.toggleLoading())
  }

  toggleLoading() {
    this.isLoading = !this.isLoading;
    this.classList.toggle("loading", this.isLoading);
  }
}

if (document.querySelector("main-blog")) {
  customElements.define("main-blog", MainBlog);
}

class MainProduct extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
    this.productVariants = JSON.parse(this.querySelector("[data-variants-data]").textContent);
    this.cart = document.querySelector("cart-drawer");

    this.currentSlide = 1;
    this.gallery = this.querySelector('[id^="ProductGallery-"]');
    this.navGallery = this.querySelector('[id^="ProductGalleryNav-"]');

    this.stickyBar = this.querySelector('[id^="ProductSticky-"]');
    this.productSubmit = this.querySelector('[id^="ProductSubmit-"]');

    this.querySelector('[id^="ProductOptions-"]')?.addEventListener("change", this.onVariantChange.bind(this));
    this.querySelector('[id^="ProductForm-"]')?.addEventListener("submit", this.onFormSubmit.bind(this));
    this.initClickListeners();

    if (this.gallery) {
      this.initGallery();
    }

    if (this.stickyBar && this.productSubmit) { 
      const needToShow = !this.isInViewport(this.productSubmit);
      this.stickyBar.classList.toggle("active", needToShow);

      window.addEventListener("scroll", () => {
        this.stickyBar.classList.toggle("active", (!this.isInViewport(this.productSubmit)));
      })
    }
  }

  onVariantChange() {
    if (this.isLoading) return;

    this.toggleLoading();

    const searchParams = new URLSearchParams(window.location.search);
    let selectedValuesLabel = '';

    [1, 2, 3].forEach(option => {
      if (this.querySelector(`[data-option="${option}"]`)) {
        if (this.querySelector(`[data-option="${option}"] input:checked`)) {
          selectedValuesLabel += ' / ' + this.querySelector(`[data-option="${option}"] input:checked`).value;
        } else {
          selectedValuesLabel += ' / ' + this.querySelector(`[data-option="${option}"] input`).value;
        }
      }
    });

    this.productVariants.forEach(variant => {
      if (variant.title === selectedValuesLabel.slice(3)) {
        if (this.querySelector("input[name='id']")) {
          this.querySelector("input[name='id']").value = variant.id;
        }
        searchParams.set('variant', variant.id);
      }
    })

    const newProductUrl = window.location.origin + window.location.pathname + `?${searchParams.toString()}`;
    window.history.replaceState({}, '', newProductUrl);

    fetch(newProductUrl)
    .then(res => res.text())
    .then(body => {
      const html = new DOMParser().parseFromString(body, "text/html");

      this.renderContent(html);
    })
    .catch(error => this.showError(error))
    .finally(() => this.toggleLoading())
  }

  onFormSubmit(event = false, skipPopup = false) {
    if (event) event.preventDefault();

    if (this.isLoading) return;

    if (this.productSubmitPopup && !skipPopup) {
      this.productSubmitPopup.classList.add("open");
      return;
    }

    const sections = [];
    if (this.cart) sections.push("cart-drawer");

    const cartData = {
      items: [
        {
          id: parseInt(this.querySelector("[name='id']").value),
          quantity: parseInt(this.querySelector("[name='quantity']").value)
        }
      ],
      sections: sections,
      sections_url: window.location.pathname
    };

    if (this.querySelector('[name="additional"]')) {
      cartData.items.push({
        id: parseInt(this.querySelector("[name='additional']").value),
        quantity: 1
      })
    }

    this.addToCart(cartData);
  }

  addToCart(data) {
    if (!data) return;

    this.toggleLoading();

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then(response => {
      if (!response.items) {
        const error = new Error(response.description);
        throw error;
      } else {
        this.toggleLoading();
        
        if (this.cart) {
          this.cart.renderContent(response.sections);
          this.cart.open();
        }
      }
    })
    .catch(error => this.showError(error))
    .finally(() => this.toggleLoading(true));
  }

  renderContent(html) {
    const section = html.querySelector(`[data-section="${this.dataset.section}"]`);
    const selectors = ['[id^="ProductSubmit-"]', '[id^="ProductSticky-"]'];

    selectors.forEach(selector => {
      const currentSelectors = this.querySelectorAll(selector);
      const newSelectors = section.querySelectorAll(selector);

      if (currentSelectors.length > 0 && currentSelectors.length == newSelectors.length) {
        currentSelectors.forEach((currentSelector, i) => {
          currentSelector.innerHTML = newSelectors[i].innerHTML;
        })
      }
    });

    if (this.querySelector('[id^="ProductSubmit-"]')) {
      const currentButton = this.querySelector('[id^="ProductSubmit-"]');
      const newButton = section.querySelector('[id^="ProductSubmit-"]');
      currentButton.toggleAttribute("disabled", newButton.disabled);
    }
  }

  initClickListeners() {
    this.addEventListener("click", (e) => {
      const productLightbox = this.querySelector('[id^="ProductLightbox-"]');
      const productLightboxComponent = productLightbox.querySelector('slider-component');

      if (e.target.hasAttribute("data-action")) {
        const quantityEl = this.querySelector('[name="quantity"]');
        const currentQuantity = parseInt(quantityEl.value);

        switch (e.target.dataset.action) {
          case "open-lightbox":
            productLightboxComponent.scrollToSlide(this.currentSlide);
            productLightbox.classList.add("open");
            document.documentElement.style.overflow = "hidden";
            break;
          case "close-lightbox":
            productLightbox.classList.remove("open");
            document.documentElement.style.overflow = null;
            break;
          case "prev-slide":
            if (this.currentSlide > 1) {
              this.currentSlide -= 1;
              this.scrollToSlide(this.currentSlide, this.gallery);
            }
            break;
          case "next-slide":
            if (this.currentSlide < this.maxLength) {
              this.currentSlide += 1;
              this.scrollToSlide(this.currentSlide, this.gallery);
            }
            break;
          case "select-slide":
            this.currentSlide = parseInt(e.target.dataset.index);
            this.scrollToSlide(this.currentSlide, this.gallery);
            break;
          case "show-reviews": 
            const reviewsBlock = document.querySelector("[data-oke-widget]");
            if (reviewsBlock) {
              reviewsBlock.scrollIntoView({behavior: "smooth",block:"center"});
            } 
            break;
          case "sticky-add": 
            this.onFormSubmit();
            break;
          case "tab-toggle": 
            const tabs = e.target.closest("[data-tabs]");
            const tabId = e.target.getAttribute("data-tab");
            tabs.querySelectorAll(".active").forEach(tab => tab.classList.remove("active"));            
            tabs.querySelectorAll(`[data-tab="${tabId}"]`).forEach(tab => tab.classList.add("active"));
            break;
          case "decrease-quantity":
            if (currentQuantity > 1) {
              quantityEl.value = currentQuantity - 1;
            }
            break;
          case "increase-quantity":
            if (currentQuantity < 99) {
              quantityEl.value = currentQuantity + 1;
            }
            break;
        }
      }
    })
  }

  initGallery() {
    this.updateGallery();
    window.addEventListener('resize', this.updateGallery.bind(this));
    this.gallery.addEventListener('scroll', this.updateGallery.bind(this));
  }

  updateGallery() {
    const items = this.gallery.querySelectorAll('[data-index]');
    const scrollLeft = this.gallery.scrollLeft;
    const scrollWidth = this.gallery.scrollWidth;
    const clientWidth = this.gallery.clientWidth;
    const blockWidth = items[0]?.offsetWidth ?? 0;
    const hasScroll = scrollWidth > clientWidth;

    const scrollbar = this.querySelector("[slider-scrollbar]");
    const scrollbarThumb = this.querySelector("[slider-scrollbar] span");
    const thumbWidth = (clientWidth / scrollWidth) * 100;
    const thumbPosition = (scrollLeft / (scrollWidth - clientWidth)) * 100;

    const prevButton = this.querySelector('[data-action="prev-slide"]');
    const nextButton = this.querySelector('[data-action="next-slide"]');

    const counter = this.querySelector("[slider-counter]");
    
    this.maxLength = items.length - (Math.floor(clientWidth / blockWidth) - 1);
    this.currentSlide = Math.round(scrollLeft / blockWidth) + 1;    

    if (scrollbarThumb) {
      scrollbarThumb.style.left = `${thumbPosition}%`;
      scrollbarThumb.style.width = `${thumbWidth}%`;
      scrollbarThumb.style.transform = `translateX(-${thumbPosition}%)`;
      scrollbar.classList.toggle("hidden", !hasScroll);
    }

    if (counter) {
      counter.innerText = `${this.currentSlide} / ${this.maxLength}`;
    }

    prevButton.toggleAttribute("disabled", this.currentSlide == 1);
    nextButton.toggleAttribute("disabled", this.currentSlide == this.maxLength);

    prevButton.classList.toggle("hidden", !hasScroll);
    nextButton.classList.toggle("hidden", !hasScroll);

    if (this.navGallery) {
      const navGallerySlides = this.navGallery.querySelectorAll("[data-index]");

      navGallerySlides.forEach((navGallerySlide, i) => {
        const index = ++i;
        navGallerySlide.classList.toggle("active", index === this.currentSlide);
      });
    }
  }

  scrollToSlide(index, slider) {    
    if (!slider) return;

    slider.scrollTo({
      left: slider.querySelector(`[data-index="${index}"]`).offsetLeft,
      behavior: 'smooth'
    });

    this.navGallery.scrollTo({
      top: this.navGallery.querySelector(`[data-index="${index}"]`).offsetTop,
      behavior: 'smooth'
    });
  }

  showError(error) {
    console.error(error);

    if (!this.querySelector("[product-notification]")) return;

    const messageBlock = this.querySelector("[product-notification]");

    messageBlock.innerText = error.message;
    setTimeout(() => {messageBlock.innerText = ''}, 5000);
    messageBlock.scrollIntoView({behavior: "smooth",block:"center"});
  }

  toggleLoading(turnOff = false) {
    this.isLoading = !this.isLoading;
    if (turnOff) this.isLoading = false;
    this.classList.toggle("loading", this.isLoading);
  }

  isInViewport(element) {
    const rect = element.getBoundingClientRect();

    const vh = window.innerHeight || document.documentElement.clientHeight;
    // Visible = any vertical part of the element is on screen. The sticky bar shows
    // whenever the real buy button is fully off-screen (above OR below the fold).
    const isInViewport = rect.top < vh && rect.bottom > 0;
    
    return isInViewport;
  };
}

if (document.querySelector("main-product")) {
  customElements.define("main-product", MainProduct);
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;

    this.initClickEvents();
  }

  connectedCallback() {
    this.initClickEvents();

    document.addEventListener("click", (e) => {
      if (e.target.hasAttribute("cart-drawer-toggle")) {
        this.open();
      }
    })
  }

  updateQuantity(item, quantity, itemEl = false) {
    this.toggleLoading(itemEl);
    
    const data = {
      line: item,
      quantity: quantity,
      sections: ["cart-drawer"],
      sections_url: window.location.pathname
    }

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(response => {
      if (response.sections) {
        this.renderContent(response.sections);
      } else {
        throw new Error(response.description);
      }
    })
    .catch((error) => {
      const itemEl = this.querySelector(`[data-item="${item}"]`);
      const messageBlock = itemEl.querySelector("[item-notification]");

      console.error('Error:', error);

      messageBlock.innerText = error.message;
      setTimeout(() => {messageBlock.innerText = ""}, 5000);
    })
    .finally(() => {this.toggleLoading(itemEl)});
  }

  renderContent(sections) {
    if (!sections['cart-drawer']) return;

    const html = new DOMParser().parseFromString(sections['cart-drawer'], "text/html");
    const newCartDrawer = html.querySelector("cart-drawer");

    const selectors = [
      '[data-content="main"]',
      '[data-content="bottom"]',
      '.cart-drawer__achivements-label'
    ];

    selectors.forEach(selector => {
      const currentBlock = this.querySelector(selector);
      const newBlock = newCartDrawer.querySelector(selector);

      if (currentBlock && newBlock) {
        currentBlock.innerHTML = newBlock.innerHTML;
      }
    })
    
    this.setAttribute("data-count", newCartDrawer.dataset.count);

    if (this.querySelector('[data-progress="shipping"]')) {
      this.querySelector('[data-progress="shipping"]').style.width = newCartDrawer.querySelector('[data-progress="shipping"]').style.width;
    }

    document.querySelectorAll("[cart-item-count]").forEach(countEl => countEl.innerText = newCartDrawer.dataset.count);
  }

  addItemToCart(item, itemEl = false) {
    this.toggleLoading(itemEl);

    const sections = ["cart-drawer"];

    const cartData = {
      items: [
        {
          id: parseInt(item),
          quantity: 1
        }
      ],
      sections: sections,
      sections_url: window.location.pathname
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartData),
    })
    .then(response => response.json())
    .then(response => {
      if (!response.items) {
        throw new Error(response.description);
      } else {
        this.renderContent(response.sections);
      }
    })
    .catch(error => console.error(error))
    .finally(() => this.toggleLoading(itemEl));
  }

  initClickEvents() {
    this.addEventListener("click", (e) => {
      e.preventDefault();

      const item = e.target.closest("[data-item]");
      const itemQuantityInput = item?.querySelector('[name="quantity"]') ?? false;
      const itemQuantity = parseInt(itemQuantityInput?.value) ?? false;

      switch (e.target.dataset.action) {
        case "close":
          this.close();
          break;
        case "remove-item":
          if (!this.isLoading) {
            this.updateQuantity(parseInt(item.dataset.item), 0);
          }
          break;
        case "decrease-quantity":          
          if (itemQuantity > 1) {
            if (!this.isLoading) {
              this.updateQuantity(parseInt(item.dataset.item), parseInt(itemQuantity - 1), item);
            }
          }
          break;
        case "increase-quantity":
          if (itemQuantity < 199) {
            if (!this.isLoading) {
              this.updateQuantity(parseInt(item.dataset.item), parseInt(itemQuantity + 1), item);
            }
          }
          break;
        case "add-upsell":
          if (!this.isLoading) {
            this.addItemToCart(e.target.dataset.variant, e.target);
          }
          break;
        case "apply-discount":
          if (!this.isLoading) {
            this.updateDiscounts();
          }
          break;
        case "remove-discount":
          if (!this.isLoading) {
            e.target.closest("[data-discount]").removeAttribute("data-discount");
            this.updateDiscounts();
          }
          break;
        case "to-checkout":
          // Route the drawer checkout button through the chekly custom checkout.
          // Never hard-redirect to the native Shopify /checkout: doing so leaks to
          // native checkout whenever chekly has not (re)bound to the freshly
          // re-rendered button. If chekly is unavailable, soft-fail instead of leaking.
          if (window.chekly && window.chekly.functions && typeof window.chekly.functions.processCheckout === "function") {
            window.chekly.functions.processCheckout();
          }
          break;
      }
    })
  }

  updateDiscounts() {
    const discountCodeElements = this.querySelectorAll("[data-discount]");
    const discountCodes = Array.from(discountCodeElements)
      .map(element => element.dataset.discount)
      .filter(Boolean);

    discountCodes.push(this.querySelector('[name="discount_code"]').value.trim());

    const discountCodesString = discountCodes.join(',');

    this.toggleLoading();

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        discount: discountCodesString,
        sections: ['cart-drawer']
      })
    })
    .then(response => response.json())
    .then(response => {
      if (response.sections) {
        this.renderContent(response.sections);
      } else {
        throw new Error(response.description);
      }
    })
    .catch((error) => console.error('Error:', error))
    .finally(() => {this.toggleLoading()});
  }

  toggleLoading(itemEl) {
    this.isLoading = !this.isLoading;
    this.classList.toggle("loading-item", this.isLoading);

    if (itemEl) {
      itemEl.classList.toggle("loading", this.isLoading);
    }
  }

  open() {
    this.classList.add("open");
    document.documentElement.style.overflow = "hidden";
  }

  close() {
    this.classList.remove("open");
    document.documentElement.style.overflow = null;
  }
}

if (document.querySelector("cart-drawer")) {
  customElements.define("cart-drawer", CartDrawer);
}
